export interface ITheme {
    mode: string;
    
    fundoMenu: string;
    textoMenu: string;
    textoMenuHover: string;
    fundoToggleTema: string;
    toggleTema: string;

    fundoObjeto: string;
    textoObjeto: string;
    serieAreaUnica: string;

    shadow: string;
}

export const darkTheme: ITheme = {
    mode: 'dark',

    fundoMenu: '#1E1E1E',
    textoMenu: '#FFF',
    textoMenuHover: '#baf40b',
    fundoToggleTema: '#000',
    toggleTema: '#c4cc45',

    fundoObjeto: '#1E1E1E',
    textoObjeto: '#FFF',
    serieAreaUnica: '#8884d8',

    shadow: '0px 4px 10px rgba(0, 0, 0, 0.5)',
};

export const lightTheme: ITheme = {
    mode: 'light',

    fundoMenu: '#70898f',
    textoMenu: '#FFF',
    textoMenuHover: '#c4cc45',
    fundoToggleTema: '#FFF',
    toggleTema: '#c4cc45',

    fundoObjeto: '#FFF',
    textoObjeto: '#70898f',
    serieAreaUnica: '#c4cc45',

    shadow: '0px 4px 10px rgba(200, 200, 200, 0.5)',
};  